import { CanActivateFn } from '@angular/router'

export const hasNoConnectionGuard: CanActivateFn = (route, state) => {
  return true;
};
